export default "__VITE_ASSET__UUptG$v3__"